import React from "react";

import styles from './OpenTaskWrapper.module.scss';
import { useOpenUpdateFormHelper } from "../../view/tasks/CreateUpdate/OpenUpdateFormField";
import {
  Project,
  TeamRole,
  useAuthenticationContextRequired,
  useProjectsService,
  useProjectTasksService
} from "nekst-api";
import { useListContextRequired } from "ui-builder";

export function OpenTaskWrapper(
  props: {
    taskId: number,
    projectId: number,
    children: React.ReactNode,
  }
) {
  const openTaskHelper = useOpenUpdateFormHelper();

  const projectTasksService = useProjectTasksService();

  const projectService = useProjectsService();

  const listContext = useListContextRequired<Project>();

  const updateProjectData = async() => {
    const updatedProject = await projectService.getById(props.projectId, true);
    listContext._updateItems([updatedProject]);
  }

  const onClick = async () => {
    const task = await projectTasksService.getTask(props.taskId);
    openTaskHelper.openForm(task, updateProjectData);
  }

  const authenticationContext = useAuthenticationContextRequired();

  const isOwnerOrAdmin = [TeamRole.OWNER, TeamRole.ADMINISTRATOR].includes(authenticationContext.user.teamRole)

  if (isOwnerOrAdmin) {
    return (
      <div className={styles.clickable} onClick={onClick}>
        {props.children}
      </div>
    );
  } else {
    return props.children;
  }

}
